import { isInGroup } from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';

const getScopePage = () => ShowPageScopeCollector.get(['layout_options', 'getIsLightweight', 'canvas_data']);

export function drawOverlayArea({ fields, canvas, id, group_fields, dimension }) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.includes("overlay_area_")) {
      canvas.remove(o);
    }
  });
  
  const { layout_options, canvas_data } = getScopePage();
  
  fields.forEach((field, index) => {
    const options = JSON.parse(field.options);
    const groupName = options["Group Name"];
    
    if (field.type === "Overlay Area" && (!group_fields || isInGroup(group_fields, field.name))) {
      const left = parseInt(options["X"]) + dimension[4].x;
      const top = parseInt(options["Y"]) + dimension[4].y;
      const width = parseInt(options["Width"]);
      const height = parseInt(options["Height"]);
      const order = parseInt(options["Order"]);
      const visible = !options['Hidden'];

      if (layout_options && layout_options.show_overlay) {
        const overlay = new fabric.Rect({
          id: "overlay_area_" + index,
          groupName: groupName,
          order,
          top,
          left: canvas_data[id].spacingFieldPosition[field.name]
            ? canvas_data[id].spacingFieldPosition[field.name].x
            : left,
          width,
          height,
          fill: options["Option1"] ? options["Option1"] : "#ffffff00",
          selectable: false,
          evented: false,
          visible
        });

        let group_x = 0;
        let group_y = 0;
        if (groupName !== "" && canvas_data[id].smartObjCoords[groupName]) {
          group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
          group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
        }
        
        overlay.set({
          left: overlay.left + group_x - dimension[2],
          top: overlay.top + group_y - dimension[3]
        });

        canvas.add(overlay);
      } else {
        const objects = canvas.getObjects();
        objects.forEach(function (o) {
          if (
            o.id !== "layout_stroke" &&
            o.order <= order &&
            (o.left < 0 || (o.left >= left && o.left <= left + width)) &&
            (o.top < 0 || (o.top >= top && o.top <= top + height))
          ) {
            canvas.remove(o);
          }
        });
      }
    }
  });
}
